/**
 * 时间戳
 * @param {*} timestamp  时间戳
 */
import settings from "@/settings";

const timestampToTime = timestamp => {
  return formatDateTime(timestamp);
};

/**
 * 秒转为时间
 * @param {number} value 秒
 */
function formatDuration(seconds) {
  const h = Math.floor(seconds / 3600)
    .toString()
    .padStart(2, "0");
  const m = Math.floor((seconds % 3600) / 60)
    .toString()
    .padStart(2, "0");
  const s = Math.floor(seconds % 60)
    .toString()
    .padStart(2, "0");

  // 如果不需要显示小时，可以去掉 h 相关的逻辑
  return `${h}:${m}:${s}`;
}

/**
 * 日期时间格式化
 * @param {Date|string|number} value 日期值（时间戳、ISO 字符串等）
 * @param {string} format 默认 YYYY-MM-DD hh:mm:ss
 */
const formatDateTime = (value, format = "YYYY-MM-DD hh:mm:ss") => {
  if (value == null || value === "") return "";
  let date = value instanceof Date ? value : new Date(value);
  if (typeof value === "number" && String(value).length === 10) {
    date = new Date(value * 1000);
  }
  if (isNaN(date.getTime())) return "";
  const pad = n => (n < 10 ? "0" + n : "" + n);
  const tokens = {
    YYYY: String(date.getFullYear()),
    MM: pad(date.getMonth() + 1),
    DD: pad(date.getDate()),
    hh: pad(date.getHours()),
    mm: pad(date.getMinutes()),
    ss: pad(date.getSeconds())
  };
  return format.replace(/YYYY|MM|DD|hh|mm|ss/g, match => tokens[match]);
};
/**
 * 存储localStorage
 */
const setStore = (name, content) => {
  if (!name) return;
  if (typeof content !== "string") {
    content = JSON.stringify(content);
  }
  window.localStorage.setItem(name, content);
};

/**
 * 获取localStorage
 */
const getStore = name => {
  if (!name) return;
  return window.localStorage.getItem(name);
};

/**
 * 删除localStorage
 */
const removeStore = name => {
  if (!name) return;
  window.localStorage.removeItem(name);
};

/**
 * 设置cookie
 **/
function setCookie(name, value, day) {
  let date = new Date();
  date.setDate(date.getDate() + day);
  document.cookie = name + "=" + value + ";expires=" + date;
}

/**
 * 获取cookie
 **/
function getCookie(name) {
  let reg = RegExp(name + "=([^;]+)");
  let arr = document.cookie.match(reg);
  if (arr) {
    return arr[1];
  } else {
    return "";
  }
}
const getHTMLContent = str =>
  str.replace(/<[^<>]+>/g, "").replace(/&nbsp;/gi, "");
/**
 * 删除cookie
 **/
function delCookie(name) {
  setCookie(name, null, -1);
}
const baseUrl = settings.baseApi || "/education-admin-api/";

function tansParams(params) {
  let result = "";
  for (const propName of Object.keys(params)) {
    const value = params[propName];
    var part = encodeURIComponent(propName) + "=";
    if (value !== null && value !== "" && typeof value !== "undefined") {
      if (typeof value === "object") {
        for (const key of Object.keys(value)) {
          if (
            value[key] !== null &&
            value[key] !== "" &&
            typeof value[key] !== "undefined"
          ) {
            let params = propName + "[" + key + "]";
            var subPart = encodeURIComponent(params) + "=";
            result += subPart + encodeURIComponent(value[key]) + "&";
          }
        }
      } else {
        result += part + value + "&";
      }
    }
  }
  return result;
}

/**
 * 解析课程课件 JSON 字符串
 * @param {string|Array} value courseware 字段
 */
function parseCourseware(value) {
  if (!value) {
    return [];
  }
  let list = value;
  if (typeof value === "string") {
    try {
      list = JSON.parse(value);
    } catch (e) {
      return [];
    }
  }
  if (!Array.isArray(list)) {
    return [];
  }
  return list.map((item, index) => normalizeCoursewareItem(item, index));
}

/** 格式化文件大小（字节） */
function formatFileSize(bytes) {
  if (bytes == null || bytes === "" || isNaN(Number(bytes))) {
    return "-";
  }
  const size = Number(bytes);
  if (size <= 0) {
    return "0 B";
  }
  const units = ["B", "KB", "MB", "GB", "TB"];
  const index = Math.min(
    Math.floor(Math.log(size) / Math.log(1024)),
    units.length - 1
  );
  const value = size / Math.pow(1024, index);
  return `${value.toFixed(index === 0 ? 0 : 2)} ${units[index]}`;
}

/** 标准化课件字段 */
function normalizeCoursewareItem(item = {}, index = 0) {
  return {
    wareId: item.wareId || item.id || `ware_${index}`,
    resourceName: item.resourceName || "",
    fileName: item.fileName || "",
    urls: item.urls || item.url || "",
    resourceType: item.resourceType,
    fileSize: item.fileSize != null ? Number(item.fileSize) : null,
    createTime: item.createTime || ""
  };
}

/**
 * 课件列表序列化为接口 JSON 字符串
 * @param {Array} list
 */
function stringifyCourseware(list = []) {
  return JSON.stringify(
    list.map(item => ({
      wareId: item.wareId,
      resourceName: item.resourceName,
      fileName: item.fileName,
      urls: item.urls,
      resourceType: item.resourceType,
      fileSize: item.fileSize,
      createTime: item.createTime
    }))
  );
}

/**
 * 导出
 **/
export {
  timestampToTime,
  formatDateTime,
  setStore,
  getStore,
  removeStore,
  setCookie,
  getCookie,
  formatDuration,
  delCookie,
  baseUrl,
  tansParams,
  getHTMLContent,
  parseCourseware,
  stringifyCourseware,
  formatFileSize
};



// WEBPACK FOOTER //
// ./src/utils/util.js